import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  FormGroup,
  Col,
  Row,
  Container,
  Label,
} from "reactstrap";
import "./index.css";
import ApiCaller from "api/apiCaller";
import Loading from "components/Loading";
import api from "api";
import { UserInfo } from "model/user";
import { ApiResponse } from "model/response";
import {
  ScheduleQuery,
  ScheduleQueryListingResponse,
} from "model/schedule_query";
import _ from "lodash";
import { DataSource, DatasourceListingResponse } from "model/datasource";
import DatasourceItem from "pages/Datasources/components/DatasourceItem";
import ReactPaginate from "react-paginate";

const PAGE_LIMIT = 6;
interface ListingData {
  datasources: Array<DataSource>;
  page: number;
  total: number;
}

export default function DatasourceListing() {
  const companyId: any = api.getCurrentCompanyId();
  const [currentUser, setCurrentUser] = useState<UserInfo | null>(null);
  const [listingData, setListingData] = useState<ListingData>({
    datasources: [],
    page: 0,
    total: 0,
  });
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {
    getListingData();
  }, [listingData?.page]);

  const initData = async () => {
    const user = api.getCurrentUser();
    setCurrentUser(user);
  };

  const getListingData = async () => {
    const res: ApiResponse = await ApiCaller.get(
      `datasource?company_id=${companyId}&is_active=1&sort_type=desc&limit=${PAGE_LIMIT}&page=${listingData?.page}`
    );
    const data: DatasourceListingResponse = res?.data;
    if (res?.status === "ok") {
      setListingData({
        ...listingData,
        ...{ datasources: data?.datasources, total: data?.total },
      });
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  if (loading) return <Loading />;

  return (
    <Container>
      <Row>
        <Col className="home-current-user-brand" xs={12}>
          <h3>
            {
              currentUser?.companies.find((comapny) => comapny.id == companyId)
                ?.name
            }
          </h3>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Button tag={Link} color="primary" to={"/create_datasource"}>
            Add new Datasource
          </Button>
        </Col>
      </Row>
      <br />
      <Row>
        <Col xs={12}>
          <ReactPaginate
            previousLabel={"<"}
            nextLabel={">"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={Math.floor(listingData?.total / PAGE_LIMIT) + 1}
            marginPagesDisplayed={3}
            pageRangeDisplayed={2}
            initialPage={0}
            onPageChange={async (page) => {
              setListingData({
                ...listingData,
                ...{ page: page.selected },
              });
            }}
            containerClassName={"pagination"}
            activeClassName={"active"}
          />
        </Col>
      </Row>
      <Row>
        {listingData?.datasources?.map((datasource) => {
          return (
            <Col xs={12} key={`${datasource?.id}`}>
              <DatasourceItem
                datasourceData={datasource}
              />
            </Col>
          );
        })}
      </Row>
    </Container>
  );
}

const styles: { [name: string]: React.CSSProperties } = {
  searchBox: {
    fontSize: 16,
    padding: 16,
    height: 48,
  },
};
